import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container fallback" }
const _hoisted_2 = { class: "fallback__top" }
const _hoisted_3 = ["alt"]

import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'FallbackPage',
  props: {
  title: {
    type: String,
    default: '',
  },
  titleSize: {
    type: String,
    default: 'large',
    validator: (size: string) => ['large', 'medium'].includes(size),
  },
  textAlignLeft: {
    type: Boolean,
    default: false,
  },
  imagePosition: {
    type: String,
    default: 'top',
    validator: (position: string) => ['top', 'background'].includes(position),
  },
},
  setup(__props) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["fallback__img-container", `fallback__img-${__props.imagePosition}`])
      }, [
        _renderSlot(_ctx.$slots, "image", {}, () => [
          _createElementVNode("picture", null, [
            _cache[0] || (_cache[0] = _createElementVNode("source", {
              srcset: "/img/empty/webp/empty.webp",
              type: "image/webp"
            }, null, -1)),
            _createElementVNode("img", {
              src: "/img/empty/empty.png",
              alt: _unref(t)('imagesAlt.vrLabs')
            }, null, 8, _hoisted_3)
          ])
        ])
      ], 2),
      (__props.title)
        ? (_openBlock(), _createElementBlock("h1", {
            key: 0,
            class: _normalizeClass(["fallback__title", `fallback__title_${__props.titleSize}`])
          }, _toDisplayString(__props.title), 3))
        : _renderSlot(_ctx.$slots, "title", { key: 1 })
    ]),
    (_ctx.$slots.text)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["fallback__text", { left: __props.textAlignLeft }])
        }, [
          _renderSlot(_ctx.$slots, "text")
        ], 2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "actions", {
      buttonClass: _ctx.$style.fallback__btn
    })
  ]))
}
}

})